import styled from 'styled-components';
import { PasswordInputTextProps } from './PasswordInputText';

export const PasswordInputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const PasswordInput = styled.input<PasswordInputTextProps>`
  outline: 0;
  height: 44px;
  width: 100%;
  transition: border 0.1s;
  border-radius: ${(p) => p.theme.radius.full};
  border: 1px solid ${(p) => (p.error ? p.theme.colors.general.error : p.theme.colors.grey[50])};
  color: ${(p) => p.theme.colors.general.text};
  font-size: ${(p) => p.theme.font.size.sm};
  box-shadow: ${(p) => p.theme.shadows.pya};
  padding: 0 12px;
  padding-right: ${(p) => (p.showToggle ? p.theme.spacing.xl : p.theme.spacing.sm)};

  &:focus {
    background-color: ${(p) => p.theme.colors.general.white};
    outline: 2px solid ${(p) => (p.error ? p.theme.colors.general.error : p.theme.colors.general.link)};
    outline-offset: -1px;
  }

  @media (max-width: ${(p) => p.theme.screen.xs}) {
    font-size: ${(p) => p.theme.font.size.xs};
  }

  &::placeholder {
    color: ${(p) => p.theme.colors.general.placeholder};
  }
`;

export const EyeIconContainer = styled.div`
  cursor: pointer;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;

  &:hover {
    opacity: 0.7;
  }

  svg {
    width: 100%;
    height: 100%;
  }
`;
